export function createMockProvider() {
  return {
    async generate(job) {
      await new Promise((resolve) => setTimeout(resolve, 80))
      return {
        images: [{ url: `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='640' height='420'%3E%3Crect width='100%25' height='100%25' fill='%231e293b'/%3E%3Ctext x='32' y='220' fill='white' font-size='26'%3E${encodeURIComponent(job.prompt.slice(0, 24) || 'v4 preview')}%3C/text%3E%3C/svg%3E` }],
      }
    },
  }
}
